import { memo } from 'react';
import { useAppSelector } from 'redux/hooks';
import { Tag } from '@doda/common/src/components/Head/metaTag';
import { formatString } from '@doda/common/src/utils/stringUtil';
import { DODA_SITE_DOMAIN } from '@doda/common/src/constants/urls';
import { DES_NM_DODA } from '@doda/common/src/constants/seo';
import {
  OGP_TYPE,
  OGP_URLJOB_SEARCH_LIST,
  OGP_IMAGE,
  OGP_SITE,
} from '@doda/common/src/constants/properties/arca';
import { rewritesUrlSelector } from 'redux/features/rewritesUrl';

export const Meta = memo(() => {
  const reqUrl = useAppSelector(rewritesUrlSelector);
  const { search } = new URL(reqUrl, DODA_SITE_DOMAIN.Production);
  const ogpUrl = formatString(OGP_URLJOB_SEARCH_LIST, [search]);

  return (
    <Tag
      title="希望条件にマッチした求人一覧 | 転職ならdoda（デューダ）"
      description={DES_NM_DODA}
      keywords="希望条件にマッチした求人一覧,転職,求人,求人情報"
      type={OGP_TYPE}
      image={OGP_IMAGE}
      url={ogpUrl}
      siteName={OGP_SITE}
      robots="NOINDEX"
    />
  );
});

Meta.displayName = 'Meta';
